// extracted by mini-css-extract-plugin
export default {"nested":"MenuDrawer_nested__5QDCG","menu-list":"MenuDrawer_menu-list__DcH74"};